﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const WeeklySessionsTile = {
    fields: {
        label: { type: "text" as const },
        colorClass: { type: "text" as const },
    },
    defaultProps: {
        label: "Sessions (7 days)",
        colorClass: "from-blue-500 to-blue-600",
    },
    inline: true,
    render: (props: any) => {
        const { label, colorClass, puck } = props as any;
        const { totalSessionsThisWeek } = useActivitiesData();
        return (
            <div ref={puck.dragRef} className={`bg-gradient-to-br ${colorClass} rounded-lg p-5 text-white`}>
                <div className="text-2xl font-bold">{totalSessionsThisWeek}</div>
                <div className="text-blue-100">{label}</div>
            </div>
        );
    },
};

export default WeeklySessionsTile;


